<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span><a id="page_x"></a>CONTENTS</span></p>
<p class="toc-text"><span><a href="#/xhtml/part01"><span class="smallcaps">PART ONE</span>: THE PRESIDENT</a></span></p>
<p class="toc-text"><span><span href="#/xhtml/part02" title="Link target outside of Sample"><span class="smallcaps">PART TWO</span>: THE SECOND MRS. WILSON</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/part03" title="Link target outside of Sample"><span class="smallcaps">PART THREE</span>: S STREET</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/endmatter2" title="Link target outside of Sample"><i>Bibliography</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/endmatter3" title="Link target outside of Sample"><i>Notes</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/endmatter4" title="Link target outside of Sample"><i>Index</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/endmatter1" title="Link target outside of Sample"><i>Acknowledgments</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/author" title="Link target outside of Sample"><i>About the Author</i></span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?066ebf34